export const formatCurrency = (amount: number, currency?: string): string => {
    const region = import.meta.env.VITE_REGION_CODE;

    // 1. Check Region FIRST to determine symbol logic
    let targetCurrency = 'PKR';
    let targetLocale = 'en-PK';

    if (region === 'UAE') {
        targetCurrency = 'AED';
        targetLocale = 'en-AE';
    }

    // We strictly use the region settings for the symbol/formatting, 
    // ignoring the 'currency' arg for the symbol determination to enforce the pricing policy.

    try {
        return new Intl.NumberFormat(targetLocale, {
            style: 'currency',
            currency: targetCurrency,
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }).format(amount);
    } catch (e) {
        console.warn("Formatting failed", e);
        const symbol = region === 'UAE' ? 'AED' : 'Rs.';
        return `${symbol} ${amount.toFixed(2)}`;
    }
};

export const formatPrice = formatCurrency;
